import axios from '../axiosConfig';
import { getAnalyticsVisitorId } from './analyticsVisitor';

const API_URL = process.env.REACT_APP_API_URL ?? '';

type AnalyticsPageConfig = {
  eventName: string;
  funnel?: string;
  step: string;
};

const PAGE_EVENT_MAP: Array<[RegExp, AnalyticsPageConfig]> = [
  [/^\/trial-request\/?$/, { eventName: 'trial_request_page_view', funnel: 'trial_signup', step: 'trial_request_page_view' }],
  [/^\/register\/?$/, { eventName: 'register_page_view', funnel: 'standard_signup', step: 'register_page_view' }],
  [/^\/verify\/?$/, { eventName: 'email_verification_page_view', funnel: 'standard_signup', step: 'email_verification_page_view' }],
  [/^\/login\/?$/, { eventName: 'login_page_view', funnel: 'login', step: 'login_page_view' }],
  [/^\/subscription\/?$/, { eventName: 'subscription_page_view', funnel: 'standard_signup', step: 'subscription_page_view' }],
  [/^\/subscription\/success\/?$/, { eventName: 'subscription_success', funnel: 'standard_signup', step: 'subscription_success' }],
  [/^\/first-login-password\/?$/, { eventName: 'first_login_password_page_view', funnel: 'trial_signup', step: 'first_login_password_page_view' }],
  [/^\/trial-profile-setup\/?$/, { eventName: 'trial_profile_setup_page_view', funnel: 'trial_signup', step: 'trial_profile_setup_page_view' }],
];

export const getPageAnalyticsConfig = (pathname: string): AnalyticsPageConfig | null => {
  const match = PAGE_EVENT_MAP.find(([pattern]) => pattern.test(pathname));
  return match?.[1] ?? null;
};

export const trackAnalyticsEvent = async (
  payload: AnalyticsPageConfig & { path?: string; metadata?: Record<string, unknown> },
): Promise<void> => {
  const visitorId = getAnalyticsVisitorId();
  if (!visitorId) {
    return;
  }

  try {
    await axios.post(`${API_URL}/api/analytics/events`, {
      eventName: payload.eventName,
      funnel: payload.funnel,
      step: payload.step,
      visitorId,
      path: payload.path ?? window.location.pathname,
      referrer: document.referrer || undefined,
      metadata: payload.metadata,
    });
  } catch (error) {
    console.warn('導線ログの送信に失敗しました', error);
  }
};
